import { useActorId, useSubjectId } from '@healthblocks-io/core'

/**
 * Hook to check if the actor is logged in for the mandatee
 * @returns true if the actor is logged in for the mandatee, false otherwise
 */
export function useLoggedInForMandatee() {
  const actorId = useActorId()
  const subjectId = useSubjectId()
  return subjectId ? subjectId !== actorId : false
}
